import React from 'react';
import { useTranslation } from 'react-i18next';

import PageLayout from '@/components/layout/PageLayout';
import { FormLayout, PermissionGuard } from '@/components/layout';
import { TabList } from '@/components/ui/navigation/TabList';
import { PrimaryButton } from '@/components/ui/buttons/PrimaryButton';
import { ScheduleGeneralForm } from '@/components/features/schedule/ScheduleGeneralForm';
import { ScheduleWorkdayForm } from '@/components/features/schedule/ScheduleWorkdayForm';
import { ScheduleBreakForm } from '@/components/features/schedule/ScheduleBreakForm';
import { useScheduleEdit } from '@/hooks/schedule/useScheduleEdit';


export const ScheduleEdit: React.FC = () => {
  const { t: translate } = useTranslation('schedule');

  const {
    formSubset,
    workdayFormSubset,
    breakFormSubset,
    scheduleId,
    activeTab,
    setActiveTab,
    isSaving,
    isLoadingCatalogs,
    handleSave,
    handleCancel,
    timezoneOptions,
    shiftGroupOptions,
    isTwoDayScheduleOptions,
  } = useScheduleEdit();

  const tabs = [
    {
      id: 'general',
      label: translate('form.tabs.general'),
      content: (
        <ScheduleGeneralForm
          form={formSubset}
          timezoneOptions={timezoneOptions}
          shiftGroupOptions={shiftGroupOptions}
          isTwoDayScheduleOptions={isTwoDayScheduleOptions}
          isEditMode={true}
          scheduleId={scheduleId}
        />
      ),
    },
    {
      id: 'workday',
      label: translate('form.tabs.workday'),
      content: <ScheduleWorkdayForm form={workdayFormSubset} />,
    },
    {
      id: 'break',
      label: translate('form.tabs.break'),
      content: <ScheduleBreakForm form={breakFormSubset} />,
    },
  ];

  return (
    <PageLayout isLoading={isLoadingCatalogs} dynamicTitle={translate('form.title.edit')}>
      <div className="flex flex-col gap-6" data-testid="schedule-edit-page">
        <TabList tabs={tabs} defaultActiveTab={activeTab} onTabChange={setActiveTab} keepMounted />

        {/* Botones – visibles en todas las pestañas (todas son formulario) */}
        <FormLayout.Footer
          cancelButton={
            <PrimaryButton
              variant="outline"
              onClick={handleCancel}
              disabled={isSaving}
              data-testid="schedule-cancel-button"
            >
              {translate('common:actions.cancel')}
            </PrimaryButton>
          }
          primaryButton={
            <PermissionGuard action="edit">
              <PrimaryButton
                onClick={handleSave}
                isLoading={isSaving}
                disabled={isSaving}
                data-testid="schedule-save-button"
              >
                {translate('common:actions.save')}
              </PrimaryButton>
            </PermissionGuard>
          }
        />
      </div>
    </PageLayout>
  );
};

export default ScheduleEdit;
